import React from 'react';
import Axios from 'axios';
import { ConnectedUserContext } from '../../connectedUser-context';

// PLAYERS: Standard 8-ball standings - Single only, with round points
// ConfigIdx 0: Standard
// ConfigIdx 1: QVNEA-BASE (old-way, ordre des entêtes différent, classement par FP, "Beauport")
// ConfigIdx 2: QVNEA-IPS
// ConfigIdx 3: QVNEA-TOPGUN
// ConfigIdx 4: BARAQUE-500

// MOVE TO DATABASE ONE DAY...  STANDINGS_CONFIG_TABLE

// TO MANAGE MANUAL TIEBREAK UPDATING THE STATS, do something like this
// db.playerMatchResults.updateMany({cumulativeType: 2, week: 7, 
//	 seasonId: ObjectId("5bb767484b018527137ddd79"), pointsFor: 334}, {$set: {roundsWin: 2.000001}})


// Constants for this standings
const cstTableHeaders = [
[
	'Rang','Joueur','#RATING#', 'MOY', 'FP','PJ', 'PP', 'PC', 'DIFF', 
	'VIC','DEF', 'ERO','EC', '10-0', 'Équipe' 
],[
	'Rang',	'Joueur', '#RATING#', 'PJ', 'FP', 'IPS', 'MOY', 'VIC', 'DEF', '% VIC', 'PP', 'PC', 'DIFF', 
	'ERO', 'EC', 'TVP', 'TVC', '10-0', 'Équipe'
],[
	'Rang', 'Joueur', '#RATING#', 'PJ', 'IPS', 'FP', 'MOY', 'VIC', 'DEF', '% VIC', 'PP', 'PC', 'DIFF', 
	'ERO', 'EC', 'TVP', 'TVC', '10-0', 'Équipe'
],[
	'Rang', 'Joueur', '#RATING#', 'MJ', 'MG', '% MG', 'IPS', 'FP', 'MOY',  
	'PJ', 'VIC', 'DEF', '% VIC', 'PP', 'PC', 'DIFF', 
	'ERO', 'EC', 'TVP', 'TVC', 'Équipe'
],[
	'Rang', 'Joueur', 'MOY', 'PJ', 'VIC', 'DEF', '% VIC', 'PP', 'PC', 'DIFF', 'Équipe'
]];

const cstDefaultSortOrder = [
[
	'','asc', 'asc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 
	'desc', 'desc', 'desc', 'desc', 'desc', 'asc'
],[
	'', 'asc', 'asc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 
	'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'asc'
],[
	'', 'asc', 'asc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 
	'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'asc'
],[
	'', 'asc', 'asc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 
	'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'asc'
],[
	'', 'asc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'asc'
]];

const cstTeamFieldIdx = [14, 18, 18, 20, 11];

const cstFixedDecimalsStats = [
[
	{fieldIdx: 3, decimals: 2},
	{fieldIdx: 4, decimals: 2}
],[
	{fieldIdx: 4, decimals: 2},		// FP
	{fieldIdx: 6, decimals: 2},		// MOY
	{fieldIdx: 9, decimals: 1}		// % VIC
],[
	{fieldIdx: 5, decimals: 2},		// FP
	{fieldIdx: 6, decimals: 2},		// MOY
	{fieldIdx: 9, decimals: 1}		// % VIC
],[
	{fieldIdx: 5, decimals: 1},		// % MG
	{fieldIdx: 7, decimals: 2},		// FP
	{fieldIdx: 8, decimals: 2},		// MOY
	{fieldIdx: 12, decimals: 1}		// % VIC
],[
	{fieldIdx: 2, decimals: 2},
	{fieldIdx: 6, decimals: 1},
]];

// 									configs:    	0  	1  	2  	3   4
const cstDefaultSortFieldIdx = 	[	4, 	4, 	4, 	4,  2];		// FP, FP, IPS, % MG, MOY
const cstDefaultSortFieldIdx2 = [	6, 	7, 	5, 	12, 7];		// PP, PP, FP, % VIC, PP
const cstDefaultSortFieldIdx3 = [	6, 	7, 	10, 15, 7];		// PP, PP, PP, DIFF, PP

// Component
class PlayerStandings_8B extends React.Component {

	static contextType = ConnectedUserContext;

  constructor(props) {
		super(props);

		this.state = {
			configIdx: 0,
			tableHeaders: cstTableHeaders[0],
			teamFieldIndex: cstTeamFieldIdx[0],
			fixedDecimalsStats: cstFixedDecimalsStats[0],

			sortOrder: cstDefaultSortOrder[0][cstDefaultSortFieldIdx[0]],
			sortFieldIdx: cstDefaultSortFieldIdx[0],

			sortStandingIdx: 0,
			standings: [],
			standingsData: [],
			standingIdx: 0,
		};
	
		this.createSelectItem = this.createSelectItem.bind(this);
		this.standTypeChange = this.standTypeChange.bind(this);
		this.createStandingHdrRow = this.createStandingHdrRow.bind(this);
		this.createStandingRow = this.createStandingRow.bind(this);
		this.createDataCell = this.createDataCell.bind(this);
		this.handleSortTable = this.handleSortTable.bind(this);
	}

	componentDidMount() {
		this.initStandings(this.props);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		this.initStandings(nextProps);
	}

	initStandings(props) {
		// Standings
		var standings = props.standings;
		// console.log('standings', standings);

		// Set Config Index according to stateloLeagueParam
		var configIdx = 0;
		if (props.season.stateloLeagueParam.includes('QVNEA-BASE')) {
			configIdx = 1;
		} else if (props.season.stateloLeagueParam.includes('QVNEA-IPS')) {
			configIdx = 2;
		} else if (props.season.stateloLeagueParam.includes('QVNEA-TOPGUN')) {
			configIdx = 3;
		}

		if (props.season.stateloLeagueParam.includes('BARAQUE-500')) {
			configIdx = 4;
		}

		this.createStandingsData(standings, configIdx);

		this.setState({
			configIdx: configIdx,
			tableHeaders: cstTableHeaders[configIdx],
			teamFieldIndex: cstTeamFieldIdx[configIdx],
			fixedDecimalsStats: cstFixedDecimalsStats[configIdx],

			sortOrder: cstDefaultSortOrder[configIdx][cstDefaultSortFieldIdx[configIdx]],
			sortFieldIdx: cstDefaultSortFieldIdx[configIdx],

			standings: standings,
			standingIdx: props.standingIdx,
		});
	}

	createStandingsData(standings, configIdx) {
		var _this = this;
		var standingsData = [];

		// Parse standings
		standings.forEach(function(standItem, standIdx) {

			var tableData = [];

			// Parse results
			standItem.results.forEach(function(result, resultIdx) {

				// Special conditions for Team column
				var teamCol = '';
				if (standItem.showTeam) {
					teamCol = result.teamName;
				}

				// Multiple players management
				var playerNamesStr = '';
				var playerRatingStr = '';
				var delimChar = '';

				for (var idx = 0; idx < result.playersName.length; idx++) {
					if (idx !== 0) { 
						delimChar = ' & ';
					}
					
					// QVNEA Leagues, show Rating Temp status
					var playerRatings = result.playersRating[idx].strValue;
					if ((configIdx >= 1) && (configIdx <= 3)) {
						playerRatings = result.playersRating[idx].strValueWithTemp;
					}

					playerNamesStr += delimChar + result.playersName[idx];
					playerRatingStr += delimChar + playerRatings;
				}

				var standingRow = [];

				switch(configIdx) {

					// STANDARD
					case 0:
						standingRow.push(0);
						standingRow.push(playerNamesStr);
						standingRow.push(playerRatingStr);
						standingRow.push(result.avg);
						standingRow.push(result.fp);
						standingRow.push(result.gamesPlayed);
						standingRow.push(result.pointsFor);
						standingRow.push(result.pointsAgainst);
						standingRow.push(result.diff);
						standingRow.push(result.gamesWon);
						standingRow.push(result.gamesLost);
						standingRow.push(result.ero);
						standingRow.push(result.eroContre);
						standingRow.push(result.dixzero);
						standingRow.push(teamCol);
						break;

					// QVNEA
					case 1:
						standingRow.push(0);
						standingRow.push(playerNamesStr);
						standingRow.push(playerRatingStr);
						standingRow.push(result.gamesPlayed);
						standingRow.push(result.fp);
						standingRow.push(result.ips);
						standingRow.push(result.avg);
						standingRow.push(result.gamesWon);
						standingRow.push(result.gamesLost);
						standingRow.push(result.pctWin);
						standingRow.push(result.pointsFor);
						standingRow.push(result.pointsAgainst);
						standingRow.push(result.diff);
						standingRow.push(result.ero);
						standingRow.push(result.eroContre);
						standingRow.push(result.tv);		// QVNEA only
						standingRow.push(result.tvContre);	// QVNEA only
						standingRow.push(result.dixzero);
						standingRow.push(teamCol);
						break;

					// QVNEA-IPS
					case 2:
						standingRow.push(0);
						standingRow.push(playerNamesStr);
						standingRow.push(playerRatingStr);
						standingRow.push(result.gamesPlayed);
						standingRow.push(result.ips);
						standingRow.push(result.fp);
						standingRow.push(result.avg);
						standingRow.push(result.gamesWon);
						standingRow.push(result.gamesLost);
						standingRow.push(result.pctWin);
						standingRow.push(result.pointsFor);
						standingRow.push(result.pointsAgainst);
						standingRow.push(result.diff);
						standingRow.push(result.ero);
						standingRow.push(result.eroContre);
						standingRow.push(result.tv);		// QVNEA only
						standingRow.push(result.tvContre);	// QVNEA only
						standingRow.push(result.dixzero);
						standingRow.push(teamCol);
						break;

					// QVNEA-TOPGUN
					case 3:
						standingRow.push(0);
						standingRow.push(playerNamesStr);
						standingRow.push(playerRatingStr);

						// Round helps when inserting manual tiebreak offset
						standingRow.push(Math.round((result.roundsWin + result.roundsLost) * 100) / 100);		// MJ
						standingRow.push(Math.round((result.roundsWin) * 100) / 100);												// MG
						standingRow.push(result.roundsWin / (result.roundsWin + result.roundsLost) * 100);	// % MG

						standingRow.push(result.ips);
						standingRow.push(result.fp);
						standingRow.push(result.avg);

						standingRow.push(result.gamesPlayed);
						standingRow.push(result.gamesWon);
						standingRow.push(result.gamesLost);
						standingRow.push(result.pctWin);

						standingRow.push(result.pointsFor);
						standingRow.push(result.pointsAgainst);
						standingRow.push(result.diff);
						standingRow.push(result.ero);
						standingRow.push(result.eroContre);
						standingRow.push(result.tv);		// QVNEA only
						standingRow.push(result.tvContre);	// QVNEA only
						standingRow.push(teamCol);
						break;						

					// BARAQUE-500
					// 'Rang', 'Joueur', 'MOY', 'PJ', 'VIC', 'DEF', '% VIC', 'PP', 'PC', 'DIFF', 'Équipe'
					case 4:
						standingRow.push(0);
						standingRow.push(playerNamesStr);
						standingRow.push(result.avg * 10);
						standingRow.push(result.gamesPlayed);
						standingRow.push(result.gamesWon);
						standingRow.push(result.gamesLost);
						standingRow.push(result.pctWin);
						standingRow.push(result.pointsFor);
						standingRow.push(result.pointsAgainst);
						standingRow.push(result.diff);
						standingRow.push(teamCol);
						break;
				}

				tableData.push(standingRow);
			});

			standingsData.push(tableData);
		});

		//console.log('standingsData')
		//console.log(standingsData)

		var sortFieldIdx = cstDefaultSortFieldIdx[configIdx];
		var sortOrder = cstDefaultSortOrder[configIdx][sortFieldIdx];

		// First data sort
		standingsData.forEach(function (standingsItemData, standingsIdx) {
			_this.sortOneStandingsData(configIdx, standingsItemData, standingsIdx, sortFieldIdx, sortOrder);
		});
	}

	resetAllSorting() {
		var _this = this;
		var configIdx = this.state.configIdx;
		var standingsData = this.state.standingsData;
		var sortFieldIdx = cstDefaultSortFieldIdx[configIdx];
		var sortOrder = cstDefaultSortOrder[configIdx][sortFieldIdx];

		standingsData.forEach(function (standingsItemData, standingsIdx) {
			_this.sortOneStandingsData(configIdx, standingsItemData, standingsIdx, sortFieldIdx, sortOrder);
		});

		this.setState({
			sortFieldIdx: sortFieldIdx,
			sortOrder: sortOrder,
		});
	}

	sortOneStandingsData(configIdx, standingsItemData, standingsIdx, sortFieldIdx, sortOrder) {
		// console.log('sortOneStandingsData:', sortFieldIdx);
		// Manage empty data
		var _this = this;
		if (standingsItemData.length !== 0) {

			var sortSign = 1;
			if (sortOrder === 'desc') { 
				sortSign = -1; 
			}

			standingsItemData.sort(function(a, b) {

				var valueA = 0;
				var valueB = 0;
				var compVal = 0;

				var fact1 = 0;
				var fact2 = 0;
				var fact3 = 0;

				// Criteria #1
				valueA = a[sortFieldIdx];
				valueB = b[sortFieldIdx];

				switch(typeof valueA) {
			    case "date":
						compVal = new Date(valueA) - new Date(valueB);
		        break;
			    case "string":
			    	// test if string is numeric
			    	if(_this.isNumeric(valueA) && _this.isNumeric(valueB)) {
							compVal = parseInt(valueA, 10) - parseInt(valueB, 10);
			    	} else {
							compVal = valueA.localeCompare(valueB);
						}
		        break;

			    case "number":
						compVal = valueA - valueB;
		        break;

			    default:
						compVal = 0;
		        break;
				}

				fact1 = (sortSign * compVal);

				// Criteria #2
				valueA = a[cstDefaultSortFieldIdx2[configIdx]];
				valueB = b[cstDefaultSortFieldIdx2[configIdx]];

				switch(typeof valueA) {
				    case "date":
						compVal = new Date(valueA) - new Date(valueB);
				        break;
				    case "string":
				    	// test if string is numeric
				    	if(_this.isNumeric(valueA) && _this.isNumeric(valueB)) {
							compVal = parseInt(valueA, 10) - parseInt(valueB, 10);
				    	} else {
							compVal = valueA.localeCompare(valueB);
						}
				        break;
				    case "number":
						compVal = valueA - valueB;
				        break;
				    default:
						compVal = 0;
				        break;
				}

				fact2 = (sortSign * compVal);

				// Criteria #3
				valueA = a[cstDefaultSortFieldIdx3[configIdx]];
				valueB = b[cstDefaultSortFieldIdx3[configIdx]];

				switch(typeof valueA) {
				    case "date":
						compVal = new Date(valueA) - new Date(valueB);
				        break;
				    case "string":
				    	// test if string is numeric
				    	if(_this.isNumeric(valueA) && _this.isNumeric(valueB)) {
							compVal = parseInt(valueA, 10) - parseInt(valueB, 10);
				    	} else {
							compVal = valueA.localeCompare(valueB);
						}
				        break;
				    case "number":
						compVal = valueA - valueB;
				        break;
				    default:
						compVal = 0;
				        break;
				}

				fact3 = (sortSign * compVal);

				// Results
				if (fact1 !== 0) {
					return fact1;
				} else if (fact2 !== 0) {
					return fact2;
				} else {
					return fact3;
				}
			});
		}

		// Reset Rank column
		if (standingsItemData[0] !== "") {
			standingsItemData.forEach(function(row, idx) {
				row[0] = idx + 1;
			});
		}

		var standingsData = this.state.standingsData;
		standingsData[standingsIdx] = standingsItemData;

		this.setState({
			standingsData: standingsData,
			sortFieldIdx: sortFieldIdx,
			sortOrder: sortOrder
		});
	}

	render() {
		// console.log('STAND: PLAYERSTANDINGS RENDER (8B)');

		let { configIdx, standings } = this.state;
    let { season } = this.props;
    const { connectedUser } = this.context;
		var hiddenRatingsMsgEnabled = !connectedUser?.isSeasonAdmin && season.hideRatingsInStandings;

		return (
			<div>
				{(standings.length > 1) ? this.dispStandTypesSelector(standings) : null}
				<br/>

				{hiddenRatingsMsgEnabled ? 
					<p className="noRatingMessages"> Les cotes des joueurs sont masquées pour les utilisateurs non-administrateurs </p> 
				: null}

				{(standings.length !== 0) ? this.dispStandings(standings, this.state.standingIdx) : null}

				<div className="no-print">
				{(configIdx === 0) ? this.createLegend() : null}
				{(configIdx === 1) ? this.createLegend_QVNEA() : null}
				{(configIdx === 2) ? this.createLegend_QVNEA() : null}
				{(configIdx === 3) ? this.createLegend_QVNEA_TOPGUN() : null}
				{(configIdx === 4) ? this.createLegend_BARAQUE500() : null}
				</div>
			</div>
		);
	}

	dispStandTypesSelector(standings) {
		return (
			<div className="row no-print">
			<div className="col-md-4">
				Options de classement
        <select className="form-control" value={this.state.standingIdx} onChange={this.standTypeChange}>
          {standings.map(this.createSelectItem)}
        </select>
			</div>
			</div>
		);
	}

  createSelectItem(standingsItem, standingsIdx) {
    return (
      <option value={standingsIdx} key={"stdType" + standingsIdx}>
      	{standingsItem.title}
      </option>
    );
  }

	standTypeChange(e) {
		this.resetAllSorting();
		this.setState({
			standingIdx: e.target.value
		});
		this.props.handleStandingIdxChange(e.target.value);
	}

	dispStandings(standings, standingsIdx) {
		var _this = this;
		var standingsItem = standings[standingsIdx];
		var standingsData = this.state.standingsData;

		//console.log('STANDINGS');
		//console.log(standingsData[standingsIdx]);

		return (
			<div className="row">
			<div className="col-md-12" key={'div.' + standingsIdx}>

				{/* NO-PRINT SECTION */}
				<div className="card no-print">
					<div className="card-header">
					<i className="fa fa-th-large"></i>
						{standingsItem.title.toUpperCase()}
					</div>

					<div className="card-body card-block">
						<div className="table-responsive tableFixHeader resizeVerticalStandings">
							<table className="table table-striped table-hover table-sm tableFix2col">
							<thead>
							<tr>
								{this.state.tableHeaders.map(function(elem, idx) {
									return _this.createStandingHdrRow(standingsIdx, elem, idx)
								})}
							</tr>
							</thead>
							<tbody>
								{(standingsData[standingsIdx].length !== 0) ?
									standingsData[standingsIdx].map(this.createStandingRow.bind(this, standingsIdx)) :
									<tr><td colSpan="99">(Aucune donnée)</td></tr>
								}
							</tbody>
							</table>
						</div>
			    </div>
				</div>

				{/* PRINT-ONLY SECTION*/}
				<div className="print-only">
					<h5>{standingsItem.title.toUpperCase()}</h5>
					<div className="table-responsive print-container">
						<table className="table table-striped table-sm">
						<thead>
						<tr>
							{this.state.tableHeaders.map(function(elem, idx) {
								return _this.createStandingHdrRow(standingsIdx, elem, idx)
							})}
						</tr>
						</thead>
						<tbody>
								{(standingsData[standingsIdx].length !== 0) ?
									standingsData[standingsIdx].map(this.createStandingRow.bind(this, standingsIdx)) :
									<tr><td colSpan="99">(Aucune donnée)</td></tr>
								}
						</tbody>
						</table>
					</div>
				</div>

		    </div>
		    </div>
		);
	}

	createStandingHdrRow(standingsIdx, hdrItem, hdrIdx) {
		var classNameStr = '';
		var onClickAction = function() {};

    // Hide TRS if parameter is set and if we are not in Admin mode
    let { season } = this.props;
    const { connectedUser } = this.context;
		var hideRatings = !connectedUser?.isSeasonAdmin && season.hideRatingsInStandings;

		if (hdrItem === "#RATING#") {
			if ((this.state.standings[standingsIdx].ratingType._id !== "0") && !hideRatings) {
				hdrItem = this.state.standings[standingsIdx].ratingType.headerTxt;
			} else {
				// hide column
				return;
			}
		}

		// No header if no team (subs)
		if((this.state.standings[standingsIdx].showTeam === false) && (hdrIdx === this.state.teamFieldIndex)) {
			return;
		}
		if((this.props.formatTeamIndiv === "INDIV") && (hdrIdx === this.state.teamFieldIndex)) {
			return;
		}

		// Sort with arrows
		// No sort on Rank (column 0)
		if (hdrIdx !== 0) {
			onClickAction = this.handleSortTable;
			classNameStr = 'statelo-sorting';
			if(hdrIdx === this.state.sortFieldIdx) {
				if (this.state.sortOrder === "asc") {
					classNameStr += ' statelo-sorting_asc';
				} else {
					classNameStr += ' statelo-sorting_desc';
				}
			}
		}

		return (
			<th key={"colid." + standingsIdx + '.' + hdrIdx} 
				id={"colid." + standingsIdx + '.' + hdrIdx} 
				className={classNameStr}
				onClick={onClickAction}>
				{hdrItem}
			</th>
		);
	}

	createStandingRow(standingsIdx, tableData, tableDataIdx) {
		return (
			<tr key={'te.' + tableDataIdx}>
				{tableData.map(this.createDataCell.bind(this, standingsIdx))}
      </tr>
    );
	}

	createDataCell(standingsIdx, dataCell, dataCellIdx) {
		// No header if no team (subs)
		if((this.state.standings[standingsIdx].showTeam === false) && (dataCellIdx === this.state.teamFieldIndex)) {
			return;
		}
		if ((this.props.formatTeamIndiv === "INDIV") && (dataCellIdx === this.state.teamFieldIndex)) {
			return;
		}

    // Hide TRS if parameter is set and if we are not in Admin mode
    let { season } = this.props;
    const { connectedUser } = this.context;
		var hideRatings = !connectedUser?.isSeasonAdmin && season.hideRatingsInStandings;

		if ( (this.state.tableHeaders[dataCellIdx] === "#RATING#") &&  
			  ( (this.state.standings[this.state.standingIdx].ratingType._id === "0") || hideRatings )) {
			return;
		}

		// Fixed number of decimals, converting to string, for averages or any other stats
		this.state.fixedDecimalsStats.forEach(function(fdItem, fdIOdx) {
			if (dataCellIdx === fdItem.fieldIdx) {
				dataCell = dataCell.toFixed(fdItem.decimals);
			}
		})

		return (
			<td key={"tdcell." + dataCellIdx}>
				{dataCell}
			</td>
		);
	}

	/* https://stackoverflow.com/questions/29810914/react-js-onclick-cant-pass-value-to-method */ 
	handleSortTable(e) {

		var _this = this;
		var standingsIdx = parseInt(e.target.id.split(".")[1], 10);
		var sortFieldIdx = parseInt(e.target.id.split(".")[2], 10);

		var configIdx = this.state.configIdx;
		var standingsData = this.state.standingsData;
		var sortOrder = this.state.sortOrder;
		var prevSortFieldIdx = this.state.sortFieldIdx;

		// Toggle sort order
		if (prevSortFieldIdx === sortFieldIdx) {
			if (sortOrder === 'asc') {
				sortOrder = 'desc';
			} else {
				sortOrder = 'asc';
			}
		} else {
			sortOrder = cstDefaultSortOrder[configIdx][sortFieldIdx];
		}

		this.setState({
			sortOrder: sortOrder,
			sortFieldIdx: sortFieldIdx,
		});

		this.sortOneStandingsData(configIdx, standingsData[standingsIdx], standingsIdx, sortFieldIdx, sortOrder);
	}

	createLegend() {
		var ratingText1 = 'TRS';
		var ratingText2 = 'TRS du joueur';

		if (this.state.standingIdx < (this.state.standings.length - 1)) {
			if (this.state.standings[this.state.standingIdx].ratingType !== null) {
				ratingText1 = this.state.standings[this.state.standingIdx].ratingType.headerTxt;
				ratingText2 = this.state.standings[this.state.standingIdx].ratingType.name;
			}
		}

		return (
			<div className="row">
			<div className="col-md-8 col-xs-12">
				<div className="card">
					<div className="card-header">
					<i className="fa fa-th-large"></i>
						LÉGENDE
					</div>

				<div className="card-block">
				<table className="table table-striped table-sm">
					
				<tbody>
				<tr key='leg1'>
					<td><b>{ratingText1}</b></td>
					<td>{ratingText2}</td>
					<td><b>DIFF</b></td>
					<td>Différentiel</td>
				</tr>
				<tr key='leg2'>
					<td><b>MOY</b></td>
					<td>Moyenne</td>
					<td><b>VIC</b></td>
					<td>Victoires</td>
				</tr>
				<tr key='leg3'>
					<td><b>FP</b></td>
					<td>Facteur de Puissance</td>
					<td><b>DEF</b></td>
					<td>Défaites</td>
				</tr>
				<tr key='leg4'>
					<td><b>PJ</b></td>
					<td>Parties Jouées</td>
					<td><b>ERO</b></td>
					<td>ERO Pour</td>
				</tr>
				<tr key='leg5'>
					<td><b>PP</b></td>
					<td>Points Pour</td>
					<td><b>EC</b></td>
					<td>ERO Contre</td>
				</tr>
				<tr key='leg6'>
					<td><b>PC</b></td>
					<td>Points Contre</td>
					<td><b>10-0</b></td>
					<td>Victoires 10-0</td>
				</tr>
				<tr key='leg7'>
					<td><b></b></td>
					<td></td>
				</tr>
					
				</tbody>
				</table>
				</div>
				</div>
			</div>

			{this.showPrintButton()}
			</div>
		);
	}

	createLegend_QVNEA() {
		var ratingText1 = 'TRS';
		var ratingText2 = 'TRS du joueur';

		if (this.state.standingIdx < (this.state.standings.length - 1)) {
			if (this.state.standings[this.state.standingIdx].ratingType !== null) {
				ratingText1 = this.state.standings[this.state.standingIdx].ratingType.headerTxt;
				ratingText2 = this.state.standings[this.state.standingIdx].ratingType.name;
			}
		}

		return (
			<div className="row">
			<div className="col-md-8 col-xs-12">
			<div className="card">
				<div className="card-header">
				<i className="fa fa-th-large"></i>
					LÉGENDE
				</div>

				<div className="card-block">
				<table className="table table-striped table-sm">				
				<tbody>
				<tr key='leg1'>
					<td><b>{ratingText1}</b></td>
					<td>{ratingText2}</td>
					<td><b>VIC</b></td>
					<td>Victoires</td>
				</tr>
				<tr key='leg2'>
					<td><b>PJ</b></td>
					<td>Parties Jouées</td>
					<td><b>DEF</b></td>
					<td>Défaites</td>
				</tr>
				<tr key='leg3'>
					<td><b>FP</b></td>
					<td>Facteur de Puissance</td>
					<td><b>% VIC</b></td>
					<td>% de victoires</td>
				</tr>
				<tr key='leg4'>
					<td><b>IPS</b></td>
					<td>Indice de Performance Statelo</td>
					<td><b>ERO</b></td>
					<td>ERO Pour</td>
				</tr>
				<tr key='leg5'>
					<td><b>MOY</b></td>
					<td>Moyenne</td>
					<td><b>EC</b></td>
					<td>ERO Contre</td>
				</tr>
				<tr key='leg6'>
					<td><b>PP</b></td>
					<td>Points Pour</td>
					<td><b>TVP</b></td>
					<td>Tables Vidées Pour</td>
				</tr>
				<tr key='leg7'>
					<td><b>PC</b></td>
					<td>Points Contre</td>
					<td><b>TVC</b></td>
					<td>Tables Vidées Contre</td>
				</tr>
				<tr key='leg8'>
					<td><b>DIFF</b></td>
					<td>Différentiel</td>
					<td><b>10-0</b></td>
					<td>Victoires 10-0</td>
				</tr>
					
				</tbody>
				</table>
				</div>

			</div>
			</div>

			{this.showPrintButton()}

			<div className="col-md-12 col-xs-12">
				<h5>Informations complémentaires</h5>
				<ul>
					<li>Dans les cas où plusieurs TRS sont représentés pour un joueur, ils sont affichés du plus ancien au plus récent. </li>
					<li>Le Facteur de Puissance (FP) est calculé en tenant compte des PP, des VIC, des 10-0 et des ERO pour et contres</li>
					<li>L'Indice de Performance Statelo (IPS) est un nouveau calcul complexe, secret et évolutif qui tient compte de plusieurs statistiques</li>
				</ul>
			</div>
			</div>
		);
	}

	createLegend_QVNEA_TOPGUN() {
		var headers = [
			'TRS', 
			'MJ', 
			'MG', 
			'IPS', 
			'FP', 
			'MOY', 
			'PJ', 
			'VIC', 
			'DEF', 
			'% VIC', 
			'PP', 
			'PC', 
			'DIFF', 
			'ERO', 
			'EC', 
			'TVP', 
			'TVC'
		];

		// PATCH FOR OTTAWA - ENGLISH
		// console.log(this.props.stateloLeagueParam);

		var headersText = [];
		if (this.props.season.stateloLeagueParam === 'QVNEA-TOPGUN-EN') {

			headersText = [
				"TRS du joueur - Player's TRS", 
				'Matchs Joués - Matches played', 
				'Matchs Gagnés - Matches won', 
				'Indice de Performance Statelo - Statelo Performance Ratio', 
				'Facteur de Puissance - Power factor', 
				'Moyenne - Average', 
				'Parties Jouées - Games played', 
				'Victoires - Games won', 
				'Défaites - Games lost', 
				'Pourcentage de Victoires - Winning %', 
				'Points Pour - Points for', 
				'Points Contre - Points against', 
				'Différentiel - Differential', 
				'Ero Pour - Ero for', 
				'Ero Contre - Ero against', 
				'Tables Vidées Pour - Table runout for', 
				'Tables Vidées Contre - Table runout against'
			];

		} else {
			headersText = [
				'TRS du joueur', 
				'Matchs Joués', 
				'Matchs Gagnés', 
				'Indice de Performance Statelo', 
				'Facteur de Puissance', 
				'Moyenne', 
				'Parties Jouées', 
				'Victoires', 
				'Défaites', 
				'Pourcentage de Victoires', 
				'Points Pour', 
				'Points Contre', 
				'Différentiel', 
				'Ero Pour', 
				'Ero Contre', 
				'Tables Vidées Pour', 
				'Tables Vidées Contre'
			];
		}

		//var ratingText1 = '';
		//var ratingText2 = '';
		//if (this.state.standingIdx < (this.state.standings.length - 1)) {
		//	ratingText1 = this.state.standings[this.state.standingIdx].ratingType.headerTxt;
		//	ratingText2 = this.state.standings[this.state.standingIdx].ratingType.name;
		//}

		//headers[0] = ratingText1;
		//headersText[0] = ratingText2;

		return (
			<div className="row">
			<div className="col-md-8 col-xs-12">
			<div className="card">
				<div className="card-header">
				<i className="fa fa-th-large"></i>
					LÉGENDE
				</div>

				<div className="card-block">
				<table className="table table-striped table-sm">				
				<tbody>
				<tr key='leg1'>
					<td><b>{headers[0]}</b></td>
					<td>{headersText[0]}</td>
					<td><b>{headers[9]}</b></td>
					<td>{headersText[9]}</td>
				</tr>
				<tr key='leg2'>
					<td><b>{headers[1]}</b></td>
					<td>{headersText[1]}</td>
					<td><b>{headers[10]}</b></td>
					<td>{headersText[10]}</td>
				</tr>
				<tr key='leg3'>
					<td><b>{headers[2]}</b></td>
					<td>{headersText[2]}</td>
					<td><b>{headers[11]}</b></td>
					<td>{headersText[11]}</td>
				</tr>
				<tr key='leg4'>
					<td><b>{headers[3]}</b></td>
					<td>{headersText[3]}</td>
					<td><b>{headers[12]}</b></td>
					<td>{headersText[12]}</td>
				</tr>
				<tr key='leg5'>
					<td><b>{headers[4]}</b></td>
					<td>{headersText[4]}</td>
					<td><b>{headers[13]}</b></td>
					<td>{headersText[13]}</td>
				</tr>
				<tr key='leg6'>
					<td><b>{headers[5]}</b></td>
					<td>{headersText[5]}</td>
					<td><b>{headers[14]}</b></td>
					<td>{headersText[14]}</td>
				</tr>
				<tr key='leg7'>
					<td><b>{headers[6]}</b></td>
					<td>{headersText[6]}</td>
					<td><b>{headers[15]}</b></td>
					<td>{headersText[15]}</td>
				</tr>
				<tr key='leg8'>
					<td><b>{headers[7]}</b></td>
					<td>{headersText[7]}</td>
					<td><b>{headers[16]}</b></td>
					<td>{headersText[16]}</td>
				</tr>				
				<tr key='leg9'>
					<td><b>{headers[8]}</b></td>
					<td>{headersText[8]}</td>
					<td><b></b></td>
					<td></td>
				</tr>
					
				</tbody>
				</table>
				</div>

			</div>
			</div>

			{this.showPrintButton()}

			<div className="col-md-12 col-xs-12">
				<h5>Informations complémentaires</h5>
				<ul>
					<li>Dans les cas où plusieurs TRS sont représentés pour un joueur, ils sont affichés du plus ancien au plus récent. </li>
					<li>Le Facteur de Puissance (FP) est calculé en tenant compte des PP, 
						des VIC, des 10-0 et des ERO pour et contres</li>
					<li>L'Indice de Performance Statelo (IPS) est un nouveau calcul complexe, 
						secret et évolutif qui tient compte de plusieurs statistiques</li>
				</ul>
			</div>
		</div>
		);
	}

	createLegend_BARAQUE500() {
		return (
			<div className="row">
			<div className="col-md-8 col-xs-12">
			<div className="card">
				<div className="card-header">
				<i className="fa fa-th-large"></i>
					LÉGENDE
				</div>

				<div className="card-block">
				<table className="table table-striped table-sm">				
				<tbody>
				<tr key='leg1'>
					<td><b>MOY</b></td>
					<td>Moyenne</td>
					<td><b>% VIC</b></td>
					<td>% de victoires</td>
				</tr>
				<tr key='leg2'>
					<td><b>PJ</b></td>
					<td>Parties Jouées</td>
					<td><b>PP</b></td>
					<td>Points pour</td>
				</tr>
				<tr key='leg3'>
					<td><b>VIC</b></td>
					<td>Victoires</td>
					<td><b>PC</b></td>
					<td>Points contre</td>
				</tr>
				<tr key='leg4'>
					<td><b>DEF</b></td>
					<td>Défaites</td>
					<td><b>DIFF</b></td>
					<td>Différentiel</td>
				</tr>

				</tbody>
				</table>
				</div>

			</div>
			</div>

			{this.showPrintButton()}
{/*
			<div className="col-md-12 col-xs-12">
				<h5>Informations complémentaires</h5>
				<ul>
					<li>Dans les cas où plusieurs TRS sont représentés pour un joueur, ils sont affichés du plus ancien au plus récent. </li>
					<li>Le Facteur de Puissance (FP) est calculé en tenant compte des PP, des VIC, des 10-0 et des ERO pour et contres</li>
					<li>L'Indice de Performance Statelo (IPS) est un nouveau calcul complexe, secret et évolutif qui tient compte de plusieurs statistiques</li>
				</ul>
			</div>
*/}
			</div>
		);
	}

	showPrintButton() {
		return (
			<div className="col-md-4 no-print">
				<button className="btn btn-secondary btn-sm btn-fluid pull-right" 
					onClick={this.printTable}> <i className="fa fa-print"></i>&nbsp;&nbsp;Imprimer le classement </button>

				<br/><br/>
				<div className="pull-right">
					<input type="checkbox" onChange={this.props.togglePrintLeagueMsg} checked={this.props.printLeagueMsg || false} />
					&nbsp;&nbsp;Imprimer le message de ligue
				</div>
			</div>
		)
	}

	printTable() {
		// replaceState remplace le URL affiché sur le printout
		var curURL = window.location.href;
		window.history.replaceState(history.state, '', '/');
		window.print();
		window.history.replaceState(history.state, '', curURL);
	}

	// isNumeric function in javascript
	isNumeric(n) {
  	return !isNaN(parseFloat(n)) && isFinite(n);
	}

}

export default PlayerStandings_8B;
